import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  // Auth is carried by the HttpOnly `access_token` cookie set by the backend.
  // Sending credentials lets it flow on every API call.
  withCredentials: true,
});

// Migration safety: clear any legacy token left over in localStorage from
// earlier builds that stored the JWT client-side (XSS-exposed).
try { localStorage.removeItem("treasury_token"); } catch { /* ignore */ }

export default api;

export const fmt = (n, ccy = "") => {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);
  const s = abs.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${sign}${s}${ccy ? " " + ccy : ""}`;
};

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toISOString().slice(0, 10);
  } catch {
    return s;
  }
};
